import { LegalLayout } from './LegalLayout';

export const TermsPage = () => (
  <LegalLayout title="Termos de Uso" updated="14 de maio de 2026">
    <p>
      Bem-vindo ao Pórtico. Estes Termos regulam o uso da plataforma de renderização
      arquitetônica disponível em <a href="https://render.prospectar.site">render.prospectar.site</a>.
      Ao criar conta ou usar qualquer parte do serviço, você concorda com este documento. Se não
      concorda, não use a plataforma.
    </p>

    <h2>1. Sobre o Pórtico</h2>
    <p>
      Pórtico é um serviço de geração de imagens fotorrealistas a partir de modelos arquitetônicos
      (SketchUp, Revit, sketches, fotos de obra) usando modelos de inteligência artificial. O
      resultado é entregue em segundos, com curadoria estética inspirada na arquitetura brasileira.
    </p>

    <h2>2. Cadastro e conta</h2>
    <ul>
      <li>Você precisa de um email válido e senha de no mínimo 8 caracteres para criar conta.</li>
      <li>Você é responsável por manter suas credenciais em sigilo.</li>
      <li>Cadastro grátis libera 3 créditos para teste, sem cobrança de cartão.</li>
      <li>É proibido criar múltiplas contas para burlar o limite gratuito. Detectamos e bloqueamos.</li>
    </ul>

    <h2>3. Créditos e cobrança</h2>
    <ul>
      <li>Cada render consome créditos conforme o tier escolhido (Draft, Standard, Premium, Variants).</li>
      <li>Assinaturas mensais (Starter, Pro, Agência) renovam créditos todo mês. Cobrança via Asaas: PIX, boleto ou cartão.</li>
      <li>Cancelamento é em 1 clique pelo painel do Asaas. Sem fidelidade, sem multa.</li>
      <li>Créditos não consumidos no mês expiram no próximo ciclo, salvo plano que diga o contrário.</li>
    </ul>

    <h2>4. Uso aceitável</h2>
    <p>Você concorda em não usar o Pórtico para:</p>
    <ul>
      <li>Gerar imagens que violem direitos autorais, marca registrada ou imagem de terceiros sem autorização.</li>
      <li>Produzir conteúdo difamatório, fraudulento, discriminatório ou ilegal.</li>
      <li>Tentar contornar limites técnicos, fazer scraping em massa ou engenharia reversa dos modelos.</li>
      <li>Sublicenciar acesso à plataforma sem autorização escrita.</li>
    </ul>

    <h2>5. Propriedade dos renders</h2>
    <p>
      Você mantém todos os direitos sobre os modelos que enviou e sobre os renders gerados a partir
      deles. Uso comercial está liberado (apresentação a clientes, portfólio, material de marketing,
      publicação em redes sociais). Detalhes no documento de <a href="/licenca-de-imagem">Licença de Imagem</a>.
    </p>

    <h2>6. Disponibilidade e limitações</h2>
    <ul>
      <li>Trabalhamos para manter o serviço 24/7, mas não garantimos uptime de 100%.</li>
      <li>Manutenções programadas podem ser anunciadas com antecedência.</li>
      <li>Em caso de falha técnica que consuma crédito sem entregar render válido, o crédito é estornado automaticamente.</li>
    </ul>

    <h2>7. Limitação de responsabilidade</h2>
    <p>
      O Pórtico fornece o serviço "como está". Não nos responsabilizamos por danos indiretos,
      lucros cessantes ou consequências decorrentes do uso dos renders gerados. Nossa
      responsabilidade total fica limitada ao valor pago nos últimos 12 meses.
    </p>

    <h2>8. Encerramento</h2>
    <p>
      Você pode encerrar sua conta a qualquer momento contatando <a href="/suporte">suporte</a>.
      Podemos suspender contas que violem estes Termos. Em caso de encerramento, dados
      pessoais são apagados conforme nossa <a href="/privacidade">Política de Privacidade</a>.
    </p>

    <h2>9. Mudanças nestes Termos</h2>
    <p>
      Podemos atualizar este documento. Mudanças relevantes são comunicadas por email com 30 dias
      de antecedência. O uso continuado após a vigência da nova versão significa aceite.
    </p>

    <h2>10. Lei aplicável</h2>
    <p>
      Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da
      comarca de São Paulo/SP para dirimir conflitos, com renúncia a qualquer outro.
    </p>

    <h2>11. Contato</h2>
    <p>
      Dúvidas? <a href="mailto:contato@portico.studio">contato@portico.studio</a> ou pela página
      de <a href="/suporte">Suporte</a>.
    </p>
  </LegalLayout>
);
